import useMediaQuery from '@material-ui/core/useMediaQuery';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { dispatchOpenShippingModalEvent } from './state';
import { ShippingCountryState } from '../../../../utils/shipping';
import { countryToFlag } from '../../../../utils/location';
import { MUI_MOBILE_BREAKPOINT } from '../../../../utils/constants';

let ShippingCurrencyModalTrigger = () => {
  const isMobile = useMediaQuery(MUI_MOBILE_BREAKPOINT);

  return ShippingCountryState.countryCode ? (
    <>
      <hr className={`sc-modal-trigger-divider`} />
      <div className={`sc-modal-trigger-wrapper`}>
        <div className="footer-title title body semibold">Language & Ship To</div>
        <button
          className={`sc-modal-trigger ${isMobile ? 'mobile' : ''}`}
          onClick={() => {
            dispatchOpenShippingModalEvent();
            window.dataLayer.push({
              event: 'language_shipto_click',
              location: 'footer', // leave static, adding it in case that module will appear in other places on the site
            });
          }}
        >
          <span className="GlobalLinkNoTx flag">{countryToFlag(ShippingCountryState.countryCode?.toLowerCase())}</span>
          <p style={{ textTransform: 'capitalize' }} className="small-p country-name">
            {ShippingCountryState?.country?.name}
          </p>
        </button>
      </div>
    </>
  ) : null;
};

ShippingCurrencyModalTrigger = observer(ShippingCurrencyModalTrigger);
export { ShippingCurrencyModalTrigger };
